'use client'

import React from 'react'

import { useTenant } from '@rewardops/auth'
import { ItemPricing } from '@rewardops/utils'

import { useTranslation } from '~/app/i18n/client'
import { useFormat } from '../../../hooks/use-format'

const PricingDetails = ({ pricing }: { pricing: ItemPricing }) => {
  const { t } = useTranslation()
  const { formatNumber } = useFormat()
  const { price, isOnSale, regularPrice } = pricing
  const tenant = useTenant()

  const saleColor = tenant.styleVariant?.pricingDetails?.saleColor

  if (isOnSale) {
    return (
      <div className="flex flex-row items-center gap-1.5 md:flex-col md:items-start md:gap-0.5 lg:flex-row lg:items-center lg:gap-2">
        <div
          className={`text-lg font-semibold leading-3`}
          style={{
            color: saleColor,
          }}
        >
          {formatNumber(price, 0)}{' '}
          <span aria-label={t('general.points')}>
            {t('general.pts').toLowerCase()}
          </span>
        </div>
        <div className="text-sm font-normal line-through">
          {formatNumber(regularPrice, 0)}{' '}
          <span aria-label={t('general.points')}>
            {t('general.pts').toLowerCase()}
          </span>
        </div>
      </div>
    )
  }

  return (
    <div className="text-lg font-semibold">
      {formatNumber(price, 0)}{' '}
      <span aria-label={t('general.points')}>
        {t('general.pts').toLowerCase()}
      </span>
    </div>
  )
}

export default PricingDetails
